import * as React from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import { SearchForm } from "security-app/components/common";
import { usePagination, useSetPagination } from "common/contexts";
const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 24px;
`;
function SearchRow({ onNewInvestigation }) {
  const pagination = usePagination();
  const setPagination = useSetPagination();
  const onNew = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onNewInvestigation();
  };
  const onSearch = (query = null) => {
    setPagination({ ...pagination, page: 1, query });
  };
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(SearchForm, { onSearch, onReset: onSearch, placeholder: "Search for investigations by name..." }), /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", "data-testid": "new-btn", onClick: onNew }, "New Investigation"));
}
export default SearchRow;
